import React, { useMemo } from 'react';
import { List } from 'immutable';
import SharedSelection from './SharedSelection';
import { KeyPathModelElement, KeyPathViewElement, useSyncKeyPath } from 'app/models/entityStateSync/keypath';
import { EntityStringId, IEntityType, ExtractIEntity } from 'app/types/entity';
import { ExtractProps } from 'app/utils/types';

interface IProps<T extends IEntityType<any>> extends Omit<ExtractProps<typeof SharedSelection>, 'path'> {
  readonly id: EntityStringId;
  readonly view: string;
  readonly type: T extends any ? IEntityType<ExtractIEntity<T>> : never;
}

function EntityViewSharedSelection<T extends IEntityType<any>>({
  id,
  view,
  type,
  children,
  ...props
}: IProps<T>) {
  const keyPathTail = useMemo(() => (
    List([
      new KeyPathModelElement({ model: type.typeName, id }),
      new KeyPathViewElement({ viewName: view }),
    ])
  ), [id, view, type]);

  const path = useSyncKeyPath({ value: keyPathTail });

  return (
    <SharedSelection {...props} path={path}>
      {children}
    </SharedSelection>
  );
}

export default React.memo(EntityViewSharedSelection);
